import React, { useState, useEffect } from "react";
import ReactBody from "react-body";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ContactForm } from "components/core/Contact";
import * as routes from "constants/routes";
import Content from "../content/Content";
import ContentImg from "../content/ContentImg";
import ContentAdd from "../content/ContentAdd";
import ContentMeta from "../content/ContentMeta";
import { Helmet } from "react-helmet-async";
import { db } from "../../firebase";

export const Voice = (props) => {
  const authUser = useSelector((state) => state.sessionState.authUser);
  const [pageContent, setPageContent] = useState(null);

  useEffect(() => {
    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }
    getContent();
  }, []);

  const getContent = () => {
    db.getPageContent("voice").then((content) => {
      setPageContent(content.val());
    });
  };

  return pageContent ? (
    <section id="voice">
      <Helmet>
        <title>
          {pageContent.meta && pageContent.meta.title
            ? pageContent.meta.title
            : "Alluvion Voice"}
        </title>
        <meta
          name="description"
          content={
            pageContent.meta && pageContent.meta.description
              ? pageContent.meta.description
              : "Alluvion Communications provides fast, smart, reliable networks in the Phoenix, AZ area. Browse all of our Fiber, Data, and Voice services and contact us."
          }
        />
      </Helmet>
      {authUser ? <ContentMeta page="voice" /> : null}
      <div className="voice-intro content-intro" id="voicecloud">
        <Content
          page="voice"
          pageContent={pageContent}
          item="header"
          type="content"
        />
        <Content
          page="voice"
          pageContent={pageContent}
          item="subHeader"
          type="content"
        />
        <Link to={routes.Contact}>
          <button className="btn btn-accent">get started</button>
        </Link>
      </div>
      <div className="voice-content">
        <div className="content-wrap">
          <div className="callout voice-callout">
            <Content
              page="voice"
              pageContent={pageContent}
              item="callout"
              type="content"
            />
            <Link to={routes.VoIP}>
              <button className="btn btn-secondary">
                Take Our VoIP Questionnaire
              </button>
            </Link>
          </div>
          <div className="voice-details">
            {pageContent.posts
              ? pageContent.posts.map((post, index) => (
                  <div
                    className="details-cell"
                    id={`content-${index}`}
                    key={index}
                  >
                    <ContentImg
                      page="voice"
                      pageContent={pageContent}
                      item="posts"
                      itemIndex={index}
                    />
                    <Content
                      page="voice"
                      pageContent={pageContent}
                      item="posts"
                      itemIndex={index}
                      type="content"
                      getContent={getContent}
                    />
                  </div>
                ))
              : null}
            {authUser ? (
              <ContentAdd
                page="voice"
                item="posts"
                type="content"
                getContent={getContent}
              />
            ) : null}
          </div>

          <div className="voice-features" id="features">
            <div className="features-row features-header">
              <div className="features-cell">
                <h4>User Features</h4>
              </div>
              <div className="features-cell">
                <h5>Basic</h5>
              </div>
              <div className="features-cell">
                <h5>Standard</h5>
              </div>
              <div className="features-cell">
                <h5>Premium</h5>
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Caller ID with Name</p>
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Speed Dial, Short Codes, Intercom Codes</p>
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Automatic Call Back, Automatic Recall</p>
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>
                  Mutiple Call Appearances, Call Waiting, Call Hold, Call
                  Transfer
                </p>
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Call Hold/Park/Pickup</p>
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Paging/Intercom Features</p>
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Shared Line Appearance</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>End User Web Portal</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Business Call Manager (BCM)</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Receptionist Features</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Voicemail</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Voicemail to Email</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Do Not Disturb</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Contact Management</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Click to Dial</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Desk phone Customization</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Desktop Client</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Mobile Apps &ndash; iOS / Android</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Voicemail Transcription</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Video Chat</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Fax to Email</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>Call Jump</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>

            <div className="features-row">
              <div className="features-cell">
                <p>CRM Integration</p>
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell">
                <i className="icon icon-square" />
              </div>
              <div className="features-cell checked">
                <i className="icon icon-check" />
              </div>
            </div>
          </div>

          <div className="voice-others">
            <Content
              page="voice"
              pageContent={pageContent}
              item="features"
              type="content"
            />
          </div>
        </div>
      </div>
      <div className="content-wrap content-contact-wrap">
        <div className="voice-contact">
          <h2>Contact us to get started</h2>
          <ContactForm />
        </div>
      </div>
      <ReactBody className="voice" />
    </section>
  ) : (
    <div className="content-intro">
      <div className="content-loading page-loading" />
    </div>
  );
};

export default Voice;
